module.exports = __webpack_public_path__ + "static/media/loading-logo.b40329bd.png";